<div class="row animate fadeIn fast">
    <div class="col-12">
        <div class="card">
            <div class="card-body bg-white">

                <input #txtTermino type="text" class="form-control" placeholder="Search SubArea..." (keyup)="buscar(txtTermino.value)" />

            </div>
        </div>
    </div>
</div>

<!-- ** Alerta cargando datos -->

<div class="row animate fadeIn fast" *ngIf="cargando">
    <div class="col-12">

        <div class="alert alert-info text-center">
            <h4 class="alert-heading">Loading</h4>
            <i class="fa fa-refresh fa-spin fa-2x"></i>
            <p class="mb-0">Please wait</p>
        </div>


    </div>
</div>


<!-- *** Tabla de Datos del Areas -->

<div class="row animate fadeIn fast" *ngIf="!cargando">
    <div class="col-12">
        <div class="card">
            <div class="card-body">


                <div class="row">

                    <div class="col-8">
                        <h4 class="card-title">SubAreas ({{subareas.length}})</h4>
                        <h6 class="card-subtitle">SubAreas Registered</h6>
                    </div>

                    <div class="col">
                        <div class="text-right">
                            <button class="btn btn-themecolor btn-sm rounded-pill" (click)="abrirSweetAlert()">
                            <i class="fa fa-hospital-o"></i>
                            New SubÁrea
                            </button>
                        </div>
                    </div>

                </div>




                <div class="table-responsive">

                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <!-- <th class="w100">Foto</th> -->
                                <th>Name SubArea</th>
                                <th class="text-nowrap w100">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of subareas">
                                <!-- <td class="text-center">
                                    <img class="w100 pointer" [src]="item.img | imagen: 'subareas'" [alt]="item.name" (click)="abrirModal( item )">
                                </td> -->
                                <td>
                                    <input type="text" class="form-control" placeholder="Nombre del item" [(ngModel)]="item.name" />
                                </td>
                                <td class="text-nowrap text-center">

                                    <button type="button" (click)="guardarCambios( item )" class="pointer" data-toggle="tooltip" data-original-title="Guardar Cambios">
                                        <i class="fa fa-edit text-inverse m-r-10"></i>
                                    </button>
                                    <button type="button" (click)="borrarSubArea( item )" class="pointer" data-toggle="tooltip" data-original-title="Borrar">
                                        <i class="fa fa-close text-danger"></i>
                                    </button>

                                </td>
                            </tr>

                        </tbody>
                    </table>
                    <!-- **Paginacion -->
                    <ngb-pagination class="float-right" [collectionSize]="collectionSize" [(page)]="page" [pageSize]="pageSize" [maxSize]="maxSize" [rotate]="true" [ellipses]="false" [boundaryLinks]="false" aria-label="Default pagination" (pageChange)="refresData()"></ngb-pagination>

                </div>

                <!-- <button class="btn btn-secondary btn-sm mr-2">Anterior</button>
                <button class="btn btn-secondary btn-sm">Siguiente</button> -->

            </div>
        </div>
    </div>
</div>